import { createFileRoute } from '@tanstack/react-router';

import { filtrosReporteSchema } from '@/entities/reporte';
import { exigirAcceso } from '@/entities/usuario';
import { ReportesPage } from '@/pages/reportes';

/**
 * Reportes se gatea SOLO por permiso (ADR-038: el permiso manda): cualquier
 * frente (`reportes:incidencias|cumplimiento|gestion`) habilita la ruta, y
 * la página afina qué pestañas se ven por frente. Por defecto solo
 * Admin/SuperAdmin traen frentes en su paquete; los demás roles entran
 * únicamente si un admin les delega alguno. El nav oculta el item con el
 * mismo criterio.
 */
export const Route = createFileRoute('/_private/reportes')({
  validateSearch: filtrosReporteSchema,
  beforeLoad: () => exigirAcceso('reportes'),
  component: ReportesPage,
});
